import { ComponentType } from '@/Enums/ComponentType'
import { Role } from '@/Enums/Role'

export const ComponentPermissionsRegistry: Record<ComponentType, Record<string, Record<Role, boolean>>> = {
    [ComponentType.TaskList]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
		},
        CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
		}
    },
    [ComponentType.ParticipantSearch]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.ParticipantInfo]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.ParticipantNotes]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        }
    },
    [ComponentType.ContactInfo]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.CaseNotes]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: true,
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanViewConditional: {
            [Role.StateAdministrator]: false,
            [Role.CaseManager]: false,
            [Role.Coordinator]: false,
            [Role.Judge]: false,
            [Role.StateUser]: false,
            [Role.Provider]: true,  // Can view only notes marked as viewable by provider
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: false,
			[Role.BatchUpload]: false
       }
    },
    [ComponentType.CaseLedger]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
       }
    },
    [ComponentType.ParticipantEligibility]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.PhaseDashboard]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanDelete: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: false,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
       },
    },
    [ComponentType.DrugTest]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.DrugTestDashboard]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.Medication]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.MedicationDashboard]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
    [ComponentType.CaseClosure]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    // ... add more permissions for the same component type if needed
    },
    [ComponentType.CriminalHistory]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
    },
	[ComponentType.OutcomeSummary]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: true,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
	},
	[ComponentType.CaseDocuments]: {
        CanEdit: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
        CanDelete: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: false,
            [Role.Coordinator]: true,
            [Role.Judge]: false,
            [Role.StateUser]: false,
            [Role.Provider]: false,
			[Role.ProbationSupervisor]: false,
			[Role.PeerSupportSpecialist]: false,
			[Role.DataEntryUser]: false,
			[Role.BatchUpload]: false
        },
        CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: true,
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: true,
			[Role.BatchUpload]: true
        },
	},
	[ComponentType.Report]: {
		CanView: {
            [Role.StateAdministrator]: true,
            [Role.CaseManager]: true,
            [Role.Coordinator]: true,
            [Role.Judge]: true,
            [Role.StateUser]: true,
            [Role.Provider]: true,
			[Role.ProbationSupervisor]: true,
			[Role.PeerSupportSpecialist]: true,
			[Role.DataEntryUser]: false,
			[Role.BatchUpload]: true
		}
	}
  // ... add more components and their corresponding permissions
}
